import { MouseEvent } from "react";
import styled from "styled-components";
import { Card, Description, Icon } from "@evergis/ui";

const SUPPOSED_TEXT_HEADER_PER_LINE = 29;

type CardBlockProps = {
  checkboxChecked?: boolean;
  onClick?: (e: MouseEvent) => void;
} & PropsOf<typeof Card>;

export const CardBlock = styled(Card)<CardBlockProps>`
  display: flex;
  flex-direction: column;
  margin: 0.0625rem;
  width: 22rem;
  height: 16.5rem;
  background-color: ${({ theme: { palette } }) => palette.background};

  @media screen and (max-height: 44rem) {
    width: 19rem;
    height: 16.5rem;
  }

  > p {
    -webkit-line-clamp: ${({ header }) =>
      typeof header === "string" && header.length > SUPPOSED_TEXT_HEADER_PER_LINE ? 1 : 3};
  }

  > div:first-child {
    height: 9.5rem;

    img {
      width: 11rem;
    }
  }
`;

export const AdditionalBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 1.5rem 1rem 0;

  ${Description} {
    display: flex;
    margin: 0;

    div {
      display: inline-flex;
      align-items: center;

      &:not(:last-child) {
        &:after {
          display: block;
          content: "";
          width: 1px;
          height: 0.5rem;
          margin-right: 0.8125rem;
          background-color: rgba(0, 0, 0, 0.12);
        }

        ${Icon} {
          margin-right: 0.8125rem;
        }
      }
    }

    ${Icon} {
      margin-right: 0.5rem;
      color: ${({ theme: { palette } }) => palette.icon};
    }
  }
`;

export const CardIconContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ApplyLabelContainer = styled.div`
  font-weight: 600;
`;
